import { Helmet } from "react-helmet";
import BackButton from "../components/BackButton";
import PdfCompressor from "../components/PdfCompressor";

const PdfCompressorTool = () => {
  return (
    <>
      <Helmet>
        <title>PDF Compressor - Free Online PDF Size Reducer</title>
        <meta
          name="description"
          content="Compress PDF files online for free. Reduce PDF file size without losing quality. No backend, no upload. 100% secure."
        />
        <meta
          name="keywords"
          content="pdf compressor, reduce pdf size, online pdf reducer, free pdf compression tool, frontend pdf compressor"
        />
        <link rel="canonical" href="https://freelity.com/pdf-compressor" />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container">
          <BackButton />
          <PdfCompressor />
        </div>
      </section>
    </>
  );
};

export default PdfCompressorTool;
